import { useQuery } from "@tanstack/vue-query";
import { useExperienceRawApi } from "@/composables/useExperienceRawApi";

export const OPERATIONAL_EXPERIENCE_OPTIONS_QUERY_KEY = "operational-experience-options";

export function useOperationalExperienceOptionsQuery(operationalIdRef: Ref<string | undefined>) {
  const { getOperationalExperienceOptions } = useExperienceRawApi();

  const isEnabled = computed(() => !!operationalIdRef.value);

  return useQuery({
    queryKey: [OPERATIONAL_EXPERIENCE_OPTIONS_QUERY_KEY, operationalIdRef],
    queryFn: () => {
      if (!operationalIdRef.value) {
        throw new Error("Operational ID is required");
      }
      return getOperationalExperienceOptions(operationalIdRef.value);
    },
    select: ({ data }) => data,
    enabled: isEnabled,
  });
}
